import axios from 'axios';
import { helperGetApiHeaders, helperGetApiRouteById, axiosErrorHandler } from 'helpers/ApiHelper';

export const FETCH_BIO_LANDING = 'FETCH_BIO_LANDING';
export const FETCH_BIO_DETAIL = 'FETCH_BIO_DETAIL';
export const CLEAR_BIO_PAGES = 'CLEAR_BIO_PAGES';

export function fetchBioLanding(id, accessToken, deviceId) {
  const pageType = 'creditListDetail';
  const request = axios
    .get(
      helperGetApiRouteById(pageType, id, '{showCode}'),
      helperGetApiHeaders({ pathKey: pageType, accessToken, deviceId }),
    )
    .catch(axiosErrorHandler);
  return {
    type: FETCH_BIO_LANDING,
    payload: request,
  };
}

export function fetchBioDetail(id, accessToken, deviceId) {
  const pageType = 'creditDetail';
  const request = axios
    .get(
      helperGetApiRouteById(pageType, id, '{creditId}'),
      helperGetApiHeaders({ pathKey: pageType, accessToken, deviceId }),
    )
    .catch(axiosErrorHandler);
  return {
    type: FETCH_BIO_DETAIL,
    payload: request,
  };
}

export function clearBioPages() {
  return {
    type: CLEAR_BIO_PAGES,
  };
}
